<template>
  <div class="shadow rounded-1">
    <h2 class="text-center pt-3">Hasil Penilaian per Kategori</h2>
    <apexchart
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: ['tahun'],
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      series: [
        {
          name: 'Berusaha',
          data: [0],
        },
        {
          name: 'Nonberusaha',
          data: [0],
        },
      ],
      chartOptions: {
        chart: {
          stacked: true,
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: '80%',
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  color: '#777777',
                },
              },
            },
          },
        },
        colors: ['#008FFB', '#FEB019'],
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [''],
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            style: {
              colors: '#78909c',
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
      },
    }
  },
  methods: {
    async loadDataChart() {
      try {
        const res = await axios.get(
          `${this.baseapi}api/dashboard/getJumlahPermohonanKlasifikasi?tahun=${this.tahun}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        const data = res.data.data
        this.series = data.series.map((d) => ({
          name: d.name,
          data: d.series,
        }))
        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            categories: [...data.categories],
          },
        }
      } catch (error) {}
    },
  },
  watch: {
    tahun: {
      handler(val) {
        this.loadDataChart()
      },
      immediate: true,
    },
  },
}
</script>
